import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';

import './fonts/San Francisco Pro Display/fonts.css';
import 'rc-slider/assets/index.css';
import 'src/fork-components/swiper/swiper.scss';
import 'src/fork-components/swiper/modules/navigation.scss';
import 'src/fork-components/swiper/modules/pagination.scss';
import './index.scss';
import { App } from './components';
import { Loader } from './components/ui';
import reportWebVitals from './reportWebVitals';
import './i18n';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <Suspense fallback={<Loader withOverlay />}>
      <App />
    </Suspense>
  </React.StrictMode>,
);

serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
